<template>
  <AppLayout fluid>
    <VContainer id="terms-page">
      <VRow
        row
        justify-center
      >
        <VCol
          md="10"
          lg="8"
          cols="12"
          align-self-center
        >
          <Privacy />
        </VCol>
      </VRow>
    </VContainer>
  </AppLayout>
</template>

<script>
import AppLayout from "@/layouts/AlternateAppLayout";
import Privacy from "@/components/App/Privacy";

export default {
  name: "Reset",
  components: {
    Privacy,
    AppLayout
  },
  data() {
    return {};
  }
};
</script>